import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AirBlowIconComponent } from './air-blow/air-blow.component';
import { AlertOctagonIconComponent } from './alert-octagon/alert-octagon.component';
import { AngleDownIconComponent } from './angle-down/angle-down.component';
import { AngleLeftIconComponent } from './angle-left/angle-left.component';
import { AngleRightSmallIconComponent } from './angle-right-small/angle-right-small.component';
import { AngleRightIconComponent } from './angle-right/angle-right.component';
import { AngleUpIconComponent } from './angle-up/angle-up.component';
import { ArrowRightIconComponent } from './arrow-right/arrow-right.component';
import { AssemblyIconComponent } from './assembly/assembly.component';
import { AwardIconComponent } from './award/award.component';
import { BellIconComponent } from './bell/bell.component';
import { CalendarIconComponent } from './calendar/calendar.component';
import { CartIconComponent } from './cart/cart.component';
import { CheckCircleIconComponent } from './check-circle/check-circle.component';
import { CheckIconComponent } from './check/check.component';
import { CloseIconComponent } from './close/close.component';
import { CoinIconComponent } from './coin/coin.component';
import { CollapseArrowIconComponent } from './collapse-arrow/collapse-arrow.component';
import { CollectionIconComponent } from './collection/collection.component';
import { CopyIconComponent } from './copy/copy.component';
import { CrownIconComponent } from './crown/crown.component';
import { DefaultSpaceIconComponent } from './default-space/default-space.component';
import { DiscordIconComponent } from './discord/discord.component';
import { DollarIconComponent } from './dollar/dollar.component';
import { EditUnderlineIconComponent } from './edit-underline/edit-underline.component';
import { EditIconComponent } from './edit/edit.component';
import { ExternalLinkIconComponent } from './external-link/external-link.component';
import { EraseIconComponent } from './erase/erase.component';
import { EvmChainIconComponent } from './evm-chain/evm-chain.component';
import { EyeIconComponent } from './eye/eye.component';
import { FacebookIconComponent } from './facebook/facebook.component';
import { FavouritesIconComponent } from './favourites/favourites.component';
import { FileCheckIconComponent } from './file-check/file-check.component';
import { FileExportIconComponent } from './file-export/file-export.component';
import { GithubIconComponent } from './github/github.component';
import { GlobeIconComponent } from './globe/globe.component';
import { GuardiansOnlyIconComponent } from './guardians-only/guardians-only.component';
import { InfoCircleIconComponent } from './info-circle/info-circle.component';
import { InfoIconComponent } from './info/info.component';
import { IotaNoBorderIconComponent } from './iota-no-border/iota-no-border.component';
import { IotaIconComponent } from './iota/iota.component';
import { LinkBrokenIconComponent } from './link-broken/link-broken.component';
import { LinkIconComponent } from './link/link.component';
import { LinkedinIconComponent } from './linkedin/linkedin.component';
import { LogOutIconComponent } from './log-out/log-out.component';
import { MarketIconComponent } from './market/market.component';
import { MembersOnlyIconComponent } from './members-only/members-only.component';
import { MembersWithBadgeIconComponent } from './members-with-badge/members-with-badge.component';
import { MembersWithNftFromCollectionIconComponent } from './members-with-nft-from-collection/members-with-nft-from-collection.component';
import { MembersIconComponent } from './members/members.component';
import { MenuIconComponent } from './menu/menu.component';
import { MoonIconComponent } from './moon/moon.component';
import { MoreIconComponent } from './more/more.component';
import { NetworkStatusIconComponent } from './network-status/network-status.component';
import { NftIconComponent } from './nft/nft.component';
import { NineDotsIconComponent } from './nine-dots/nine-dots.component';
import { OpenSaleIconComponent } from './open-sale/open-sale.component';
import { PercentageIconComponent } from './percentage/percentage.component';
import { PlusIconComponent } from './plus/plus.component';
import { PremiumIconComponent } from './premium/premium.component';
import { PoolIconComponent } from './pool/pool.component';
import { QuestionCircleIconComponent } from './question-circle/question-circle.component';
import { RedditIconComponent } from './reddit/reddit.component';
import { RefreshIconComponent } from './refresh/refresh.component';
import { RevertIconComponent } from './revert/revert.component';
import { RocketIconComponent } from './rocket/rocket.component';
import { SadCryIconComponent } from './sad-cry/sad-cry.component';
import { SadIconComponent } from './sad/sad.component';
import { SearchPlusIconComponent } from './search-plus/search-plus.component';
import { SearchIconComponent } from './search/search.component';
import { ShareIconComponent } from './share/share.component';
import { ShimmerIconComponent } from './shimmer/shimmer.component';
import { SoonlabsIconComponent } from './soonlabs/soonlabs.component';
import { SortIconComponent } from './sort/sort.component';
import { SpaceIconComponent } from './space/space.component';
import { SpecificMembersOnlyIconComponent } from './specific-members-only/specific-members-only.component';
import { StopwatchIconComponent } from './stopwatch/stopwatch.component';
import { SunIconComponent } from './sun/sun.component';
import { StakingIconComponent } from './staking/staking.component';
import { SwapIconComponent } from './swap/swap.component';
import { SwitchIconComponent } from './switch/switch.component';
import { TagIconComponent } from './tag/tag.component';
import { ThumbUpIconComponent } from './thumb-up/thumb-up.component';
import { ThumbDownIconComponent } from './thumb-down/thumb-down.component';
import { TerminatedIconComponent } from './terminated/terminated.component';
import { TimeIconComponent } from './time/time.component';
import { TokenIconComponent } from './token/token.component';
import { TrashIconComponent } from './trash/trash.component';
import { TwitterIconComponent } from './twitter/twitter.component';
import { UnamusedIconComponent } from './unamused/unamused.component';
import { UserPlusIconComponent } from './user-plus/user-plus.component';
import { VerifiedIconComponent } from './verified/verified.component';
import { WalletIconComponent } from './wallet/wallet.component';

@NgModule({
  declarations: [
    GlobeIconComponent,
    RocketIconComponent,
    MoreIconComponent,
    UnamusedIconComponent,
    SunIconComponent,
    MoonIconComponent,
    MembersIconComponent,
    MarketIconComponent,
    BellIconComponent,
    SpaceIconComponent,
    AwardIconComponent,
    CheckCircleIconComponent,
    QuestionCircleIconComponent,
    AngleDownIconComponent,
    AngleUpIconComponent,
    TwitterIconComponent,
    FacebookIconComponent,
    LinkedinIconComponent,
    GithubIconComponent,
    LogOutIconComponent,
    DiscordIconComponent,
    RedditIconComponent,
    AngleLeftIconComponent,
    MenuIconComponent,
    PlusIconComponent,
    PremiumIconComponent,
    CloseIconComponent,
    AngleRightIconComponent,
    InfoIconComponent,
    SoonlabsIconComponent,
    SortIconComponent,
    CheckIconComponent,
    DefaultSpaceIconComponent,
    SearchIconComponent,
    EraseIconComponent,
    EditIconComponent,
    EyeIconComponent,
    TerminatedIconComponent,
    AirBlowIconComponent,
    WalletIconComponent,
    VerifiedIconComponent,
    ExternalLinkIconComponent,
    LinkIconComponent,
    RefreshIconComponent,
    ArrowRightIconComponent,
    StakingIconComponent,
    TrashIconComponent,
    TagIconComponent,
    ThumbUpIconComponent,
    ThumbDownIconComponent,
    TimeIconComponent,
    ShareIconComponent,
    PercentageIconComponent,
    DollarIconComponent,
    CopyIconComponent,
    SadIconComponent,
    CrownIconComponent,
    StopwatchIconComponent,
    AlertOctagonIconComponent,
    InfoCircleIconComponent,
    UserPlusIconComponent,
    CollectionIconComponent,
    CalendarIconComponent,
    AngleRightSmallIconComponent,
    MembersOnlyIconComponent,
    SwapIconComponent,
    PoolIconComponent,
    GuardiansOnlyIconComponent,
    MembersWithBadgeIconComponent,
    MembersWithNftFromCollectionIconComponent,
    NineDotsIconComponent,
    OpenSaleIconComponent,
    RevertIconComponent,
    CoinIconComponent,
    FileCheckIconComponent,
    SwitchIconComponent,
    FileExportIconComponent,
    TokenIconComponent,
    EditUnderlineIconComponent,
    CollapseArrowIconComponent,
    IotaIconComponent,
    ShimmerIconComponent,
    AssemblyIconComponent,
    EvmChainIconComponent,
    NetworkStatusIconComponent,
    IotaNoBorderIconComponent,
    NftIconComponent,
    FavouritesIconComponent,
    SearchPlusIconComponent,
    SpecificMembersOnlyIconComponent,
    SadCryIconComponent,
    LinkBrokenIconComponent,
    CartIconComponent,
  ],
  exports: [
    GlobeIconComponent,
    RocketIconComponent,
    MoreIconComponent,
    UnamusedIconComponent,
    SunIconComponent,
    MoonIconComponent,
    MembersIconComponent,
    MarketIconComponent,
    BellIconComponent,
    SpaceIconComponent,
    AwardIconComponent,
    CheckCircleIconComponent,
    QuestionCircleIconComponent,
    AngleDownIconComponent,
    AngleUpIconComponent,
    TwitterIconComponent,
    LogOutIconComponent,
    FacebookIconComponent,
    LinkedinIconComponent,
    GithubIconComponent,
    DiscordIconComponent,
    RedditIconComponent,
    AngleLeftIconComponent,
    MenuIconComponent,
    PlusIconComponent,
    PremiumIconComponent,
    CloseIconComponent,
    AngleRightIconComponent,
    InfoIconComponent,
    SoonlabsIconComponent,
    SortIconComponent,
    CheckIconComponent,
    DefaultSpaceIconComponent,
    SearchIconComponent,
    EraseIconComponent,
    StakingIconComponent,
    EditIconComponent,
    EyeIconComponent,
    TerminatedIconComponent,
    AirBlowIconComponent,
    WalletIconComponent,
    VerifiedIconComponent,
    ExternalLinkIconComponent,
    LinkIconComponent,
    RefreshIconComponent,
    ArrowRightIconComponent,
    TrashIconComponent,
    TagIconComponent,
    ThumbUpIconComponent,
    ThumbDownIconComponent,
    TimeIconComponent,
    ShareIconComponent,
    PercentageIconComponent,
    DollarIconComponent,
    CopyIconComponent,
    SadIconComponent,
    CrownIconComponent,
    StopwatchIconComponent,
    AlertOctagonIconComponent,
    InfoCircleIconComponent,
    UserPlusIconComponent,
    CollectionIconComponent,
    CalendarIconComponent,
    AngleRightSmallIconComponent,
    MembersOnlyIconComponent,
    GuardiansOnlyIconComponent,
    MembersWithBadgeIconComponent,
    MembersWithNftFromCollectionIconComponent,
    NineDotsIconComponent,
    OpenSaleIconComponent,
    RevertIconComponent,
    CoinIconComponent,
    FileCheckIconComponent,
    SwitchIconComponent,
    FileExportIconComponent,
    TokenIconComponent,
    EditUnderlineIconComponent,
    CollapseArrowIconComponent,
    IotaIconComponent,
    ShimmerIconComponent,
    AssemblyIconComponent,
    EvmChainIconComponent,
    NetworkStatusIconComponent,
    IotaNoBorderIconComponent,
    NftIconComponent,
    FavouritesIconComponent,
    SearchPlusIconComponent,
    SpecificMembersOnlyIconComponent,
    SadCryIconComponent,
    LinkBrokenIconComponent,
    CartIconComponent,
  ],
  imports: [CommonModule],
})
export class IconModule {}
